import { ErrorDialogContext } from '../providers/ErrorDialog';
import { useContext } from 'react';

export const useErrorDialog = () => useContext(ErrorDialogContext);
